import React from 'react';
import { Grid } from '@material-ui/core';
import { CspDetailItem as BrandDetailItem } from '../../../Csp/components';
import { BRAND_RELATIONSHIP_SCORE } from '../../../../../constants';
import { Brand } from '../../../Brands/types';

interface CampaignBrandDetailsProps {
  brandInfo?: Brand;
}

const CampaignBrandDetails: React.FC<CampaignBrandDetailsProps> = ({
  brandInfo,
}) => {
  const brandRelation = BRAND_RELATIONSHIP_SCORE.find(
    (item) => item.value === brandInfo?.brandRelationshipScore
  )?.label;

  return (
    <Grid container data-testid="campaignBrandDetails">
      <Grid item xs={6}>
        <BrandDetailItem
          title="Brand Legal Name"
          value={
            brandInfo?.entityType === 'SOLE_PROPRIETOR'
              ? 'Redacted due to PII'
              : brandInfo?.companyName
          }
        />
        <BrandDetailItem title="Country" value={brandInfo?.country} />
        <BrandDetailItem title="EIN" value={brandInfo?.ein} />
        <BrandDetailItem title="Stock Symbol" value={brandInfo?.stockSymbol} />
        <BrandDetailItem
          title="Website/Online Presence"
          value={brandInfo?.website}
        />
        <BrandDetailItem
          title="Support Phone Number"
          value={brandInfo?.phone}
        />
        <BrandDetailItem
          title="Political Committee Locale"
          value={
            (brandInfo?.optionalAttributes
              ?.politicalCommitteeLocale as string) || null
          }
        />
      </Grid>
      <Grid item xs={6}>
        <BrandDetailItem
          title="Brand ID"
          value={brandInfo?.uid}
          link={brandInfo?.uid ? `/brands/${brandInfo?.uid}` : undefined}
        />
        <BrandDetailItem title="State" value={brandInfo?.state} />
        <BrandDetailItem
          title="EIN Issuing Country"
          value={brandInfo?.einIssuingCountry}
        />
        <BrandDetailItem
          title="Stock Exchange"
          value={brandInfo?.stockExchange}
        />
        <BrandDetailItem title="Brand Relationship" value={brandRelation} />
        <BrandDetailItem title="Vertical" value={brandInfo?.vertical} />
        <BrandDetailItem
          title="Government Entity"
          value={
            brandInfo?.optionalAttributes?.governmentEntity ? 'True' : 'False'
          }
        />
      </Grid>
    </Grid>
  );
};

export default CampaignBrandDetails;
